var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loadStatus)?_c('div',_vm._l((15),function(i){return _c('Skeleton',{key:i,attrs:{"width":"100%","height":"3.5rem"}})}),1):(_vm.recipientList.length)?_c('div',[_c('RecipientList',{attrs:{"recipients":_vm.recipientList}})],1):_c('div',[_c('EmptyState')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }